<template>
  <div class="monitoring-info">
    <div class="monitoring-info__header">
      <div class="monitoring-info__header-title">
        {{ $t('affiliates.monitored.monitoring') }}
      </div>
      <div class="monitoring-info__header-buttons-wrapper">
        <div
          class="monitoring-info__header-button monitoring-info__header-button_stop"
          @click="$emit('stop');"
        >
          <UiIcon
            name="stop"
            class="t:mr-4"
            color="var(--text-negative)"
          />
          {{ $t('affiliates.monitored.actionStop') }}
        </div>
        <div
          class="monitoring-info__header-button monitoring-info__header-button_edit"
          @click="$emit('edit');"
        >
          <UiIcon
            name="pen"
            color="inherit"
            class="t:mr-4"
          />
          {{ $t('affiliates.affiliatesInfo.edit') }}
        </div>
      </div>
    </div>
    <div class="monitoring-info__content">
      <div class="monitoring-info__content-title">
        {{ $t('affiliates.monitored.reason') }}
      </div>
      <div class="monitoring-info__content-reason">
        {{ info.reason }}
      </div>
    </div>
    <div
      v-if="info.expires_at"
      class="monitoring-info__footer"
    >
      <span>{{ $t('affiliates.monitored.notify') }}</span>
      <span>{{ $filters.formatDate3(info.expires_at) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: [Object, null],
      required: true,
      default: () => null,
    },
  },
  emits: ['stop', 'edit'],
};
</script>

<style lang="scss">
.monitoring-info {
  padding: 8px;
  border-radius: 8px;
  background-color: rgba(210, 99, 112, 0.08);
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #303634;
  overflow: hidden;


  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  &__header-title{
    font-weight: 500;
    color: #212529;
  }
  &__header-buttons-wrapper {
    display: flex;
    align-items: center;
  }
  &__header-button {
    display: flex;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    margin-left: 16px;
    &_stop {
      color: var(--text-negative);
    }
    &_edit {
      color: var(--text-primary);
    }
  }


  &__content{
    padding: 8px 0;
  }
  &__content-title{
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 4px;
  }
  &__content-reason{
    white-space: pre-wrap;
    word-break: break-word;
  }


  &__footer {
    border-top: 1px solid #dee2e6;
    padding-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
